/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function SelectRecipients({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  disabled,
  sx = { width: "100%" },
}) {
  const axiosPrivate = useAxiosPrivate();
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/I-Abide/getAllOffices`)
      .then((res) => {
        setSelectedRecipients(res?.data);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  // Initialize the selected recipient based on the current value
  const [selectedSingleRecipient, setSelectedSingleRecipient] = useState(
    selectedRecipients?.find((recipient) => recipient.id === value) || null
  );

  useEffect(() => {
    setSelectedSingleRecipient(
      selectedRecipients?.find((recipient) => recipient.id === value) || null
    );
  }, [selectedRecipients, value]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);

    if (newValue) {
      onChange?.(name, newValue || "");
      setSelectedSingleRecipient(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, "");
    setSelectedSingleRecipient(null);
  };

  console.log(selectedRecipients);

  return (
    <Box>
      <TextField
        label={error ? `${label} - ${error}` : label}
        placeholder={error ? `${placeholder} - ${error}` : placeholder}
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disabled}
        value={
          selectedSingleRecipient ? selectedSingleRecipient.officeName : ""
        }
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            <>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <>
                  {selectedSingleRecipient && (
                    <IconButton edge="end" onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  {!disabled && !error && (
                    <IconButton edge="end" onClick={handleClick}>
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </>
              )}
            </>
          ),
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {selectedRecipients.map((recipient) => (
          <MenuItem
            sx={{ width: "100%" }}
            key={recipient.id}
            onClick={() => handleClose(recipient)}
          >
            {recipient.officeName}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
